import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"

import account from './modules/account'
import auth from './modules/auth'

Vue.use(Vuex);

/*let siteUrl = 'http://polifarb-color-back';*/
let siteUrl = 'http://api.color.polifarb.ua';


const URL_CATALOGS = siteUrl+"/api/catalogs";
const URL_COLORS = siteUrl+'/api/color/';
const URL_PRODUCTS = siteUrl+'/api/products/';
const URL_RECIPE = siteUrl+'/api/recipe/';
const URL_STORY = siteUrl+'/api/story/';
export default new Vuex.Store({
    modules: {
        account,
        auth
    },
    state: {
        preloader: false,
        catalog: [],
        color: [],
        product: [],
        recipe: [],
        story:'',
        error:''
    },
    mutations: {
        updateCatalogs: (state, response) => {
            state.catalog = response;
        },
        updateColors: (state, response) => {
            state.color = response;
        },
        updateProducts: (state, response) => {
            state.product = response;
        },
        updateRecipe: (state, response) => {
            state.recipe = response;
        },
        send_request(state){
            state.story = 'loading'
        },
        preloader(state, bool){
            state.preloader = bool;
        },
        response_error(state, error){
            if (error.response.data.message === 'Ожидайте подтверждение администратором!') {
                localStorage.removeItem('token');
            }

        }

    },
    actions: {
        loadCatalogs({commit}) {
            commit('preloader', true);
            axios.get(URL_CATALOGS).then((response) => {
                commit("updateCatalogs", response.data)
                commit('preloader', false);
            }).catch((error) => {
                commit("response_error", error)
                console.log(error.message)
            })
        },
        loadColors({commit}, id) {
            commit('preloader', true);
            axios.get(URL_COLORS + id).then((response) => {
                commit('preloader', false);
                commit("updateColors", response.data);
            }).catch((error) => {
                commit("response_error", error)
                console.log(error)
            })
        },
        loadProducts({commit}, id) {
            commit('preloader', true);
            axios.get(URL_PRODUCTS + id).then((response) => {
                commit('preloader', false);
                commit("updateProducts", response.data);
            }).catch((error) => {
                commit("response_error", error)
                console.log(error.message)
            })
        },
        loadRecipe({commit}, id) {
            commit('preloader', true);
            axios.get(URL_RECIPE + id).then((response) => {
                commit('preloader', false);
                commit("updateRecipe", response.data)
            }).catch((error) => {
                commit("response_error", error)
            })
        },
        loadStory({commit}, arr) {
            axios.post(URL_STORY , arr).then((response) => {
                commit("send_request", response.data)
            }).catch((error) => {
                commit("response_error", error)
            })

        },
        /*loadStory({commit}, arr) {
            return new Promise((resolve, reject) => {
                axios({url: URL_STORY, data: arr, method: 'POST' })
                    .then(resp => {
                        commit('send_request')
                        resolve(resp.data.message)
                    })
                    .catch(err => {
                        reject(err.response.data)
                    })
            })

        }*/
    },
    getters: {
        catalog(state) {
            return state.catalog;
        },
        sendError(state){
            return state.error;
        },
        color(state) {
            return state.color;
        },
        product(state) {
            return state.product;
        },
        recipe(state) {
            return state.recipe;
        },
        preloader(state) {
            return state.preloader;
        }
    }

});
